//tslint:disable

import { IAnswerSchema } from './AnswerSchema';
import { ICheckboxQuestionSchema } from './CheckboxQuestionSchema';
import { IHelpTextSchema } from '../help_text/HelpTextSchema';

export interface IQuestionSchema {
  /** Название поля, под которым будет храниться ответ. Например: «dealType» **/
  answerField: EAnswerField;
  /** Тип ответа. Пример: bool/list/str и т.д. **/
  answerType: EAnswerType;
  /** Варианты ответов, если применимо **/
  answers?: IAnswerSchema[] | null;
  /** Дополнительные вопросы-чекбоксы. Пример: «включая налоги» **/
  checkboxes?: ICheckboxQuestionSchema[] | null;
  /** Код вопроса, его уникальный идентификатор **/
  code: ECode;
  /** Пояснительный текст для вопроса **/
  helpText?: IHelpTextSchema | null;
  /** Надо ли отображать в вопросе иконки/картинки **/
  iconType?: EIconType | null;
  /** Плейсхолдер **/
  placeholder?: string | null;
  /** Заголовок вопроса. Пример: «Чем риелтор может вам помочь?» **/
  title: string;
  /** Тип вопроса. Пример: «one_choice» **/
  type: EType;
  /** Единицы измерения **/
  unit?: string | null;
}

export enum EAnswerField {
  /** Поле для ответа отсутствует **/
  Absent = 'absent',
  /** Укажите адрес **/
  Address = 'address',
  /** Какая техника есть в квартире? **/
  Appliances = 'appliances',
  /** Оцените стоимость {техники и мебели} **/
  AppliancesAndFurnitureCost = 'appliancesAndFurnitureCost',
  /** Укажите общую площадь **/
  Area = 'area',
  /** Площадь от **/
  AreaFrom = 'areaFrom',
  /** Площадь до **/
  AreaTo = 'areaTo',
  /** Укажите высоту потолков **/
  CeilingHeight = 'ceilingHeight',
  /** Можно с детьми? **/
  ChildrenAllowed = 'childrenAllowed',
  /** Комфорт **/
  Comfort = 'comfort',
  /** Есть, что добавить? / Опишите вашу ситуацию **/
  Comment = 'comment',
  /** Рассматриваете ли вы возможность начать сотрудничество с риэлтором? **/
  CooperationStatus = 'cooperationStatus',
  /** Как срочно хотите совершить сделку? **/
  DealPeriod = 'dealPeriod',
  /** Как срочно хотите совершить сделку? (признак эксперимента) **/
  DealPeriodExperimental = 'dealPeriodExperimental',
  /** Чем риелтор может вам помочь? так-то это dealType, только странный **/
  DealTypeEx = 'dealTypeEx',
  /** Введите адрес электронной почты **/
  Email = 'email',
  /** Новостройка или вторичка? **/
  FirstOrSecond = 'firstOrSecond',
  /** На каком этаже расположена квартира? **/
  Floor = 'floor',
  /** Сколько этажей в доме? **/
  FloorMax = 'floorMax',
  /** Форма с выбранными риэлторами отправлена **/
  FormSentWithRealtors = 'formSentWithRealtors',
  /** Как вас зовут? **/
  FullName = 'fullName',
  /** Похоже, вы уже оценивали эту квартиру **/
  HasEstimation = 'hasEstimation',
  /** Системный AnswerField под наличие объявлений аренды **/
  HasRentOfferData = 'hasRentOfferData',
  /** Системный AnswerField под наличие объявлений продажи **/
  HasSaleOfferData = 'hasSaleOfferData',
  /** Скрытый шаг для отправки формы **/
  HiddenSubmitter = 'hiddenSubmitter',
  /** Укажите тип дома **/
  HouseMaterialType = 'houseMaterialType',
  /** Включая коммунальные платежи **/
  IncludeCommunal = 'includeCommunal',
  /** Включая эксплуатационные налоги **/
  IncludeOperationalTaxes = 'includeOperationalTaxes',
  /** Вопрос, где нужно выбрать инфраструктуру **/
  Infrastructure = 'infrastructure',
  /** Вы агент по недвижимости? **/
  IsAgent = 'isAgent',
  /** Доступнен ли выбор риэлторов? **/
  IsAvailableRealtorChoice = 'isAvailableRealtorChoice',
  /** Объект в залоге у банка? **/
  IsBankDeposit = 'isBankDeposit',
  /** Планируете брать кредит? **/
  IsCredit = 'isCredit',
  /** Вы уже разместили объявление? **/
  IsHasOffer = 'isHasOffer',
  /** Вы получили квартиру в наследство? **/
  IsInheritance = 'isInheritance',
  /** В числе собственников есть несовершеннолетние? **/
  IsMinorOwners = 'isMinorOwners',
  /** Уже накопили на первоначальный взнос? **/
  IsMortgageInitialPayment = 'isMortgageInitialPayment',
  /**  **/
  IsOfferDataCorrect = 'isOfferDataCorrect',
  /** Вы знаете параметры квартиры и дома? **/
  IsOfferParamsKnown = 'isOfferParamsKnown',
  /** Уже выбрали проект дома под строительство? **/
  IsProjectExists = 'isProjectExists',
  /** Вы готовы снизить цену, в случае необходимости? **/
  IsReadyToLower = 'isReadyToLower',
  /** В квартире такая планировка? **/
  Layout = 'layout',
  /** Будете заключать договор аренды? **/
  LeaseAgreement = 'leaseAgreement',
  /** Есть лоджия или балкон? **/
  LoggiaOrBalcony = 'loggiaOrBalcony',
  /** Уже есть одобрение ипотеки от банка? **/
  MortgageBankApprove = 'mortgageBankApprove',
  /** Рассматриваете вариант покупки участка и постройки {дома}? **/
  NeedLandForBuilding = 'needLandForBuilding',
  /** Хотите подобрать проект дома и рассчитать его примерную стоимость? **/
  NeedProject = 'needProject',
  /** Уточните тип недвижимости **/
  ObjectType = 'objectType',
  /** Выберите объявление **/
  Offer = 'offer',
  /** Какую недвижимость хотите продать? **/
  OfferType = 'offerType',
  /** Мы нашли объявления квартир с похожими параметрами. Вы хотите оценить квартиру из объявления? **/
  OffersFound = 'offersFound',
  /** В течение последних 10 лет в квартире производился капитальный ремонт? **/
  Overhaul = 'overhaul',
  /** Можно с животными? **/
  PetsAllowed = 'petsAllowed',
  /** Укажите номер мобильного телефона (с смс подтверждением) **/
  Phone = 'phone',
  /** Укажите номер мобильного телефона **/
  PhoneVerify = 'phoneVerify',
  /** Укажите предпочитаемую цену **/
  Price = 'price',
  /** Цена от **/
  PriceFrom = 'priceFrom',
  /** Цена до **/
  PriceTo = 'priceTo',
  /** Как планируете покупать квартиру? **/
  PurchaseMethod = 'purchaseMethod',
  /** Шаг с выбором риэлторов **/
  RealtorListing = 'realtorListing',
  /** Срок аренды **/
  RentType = 'rentType',
  /** Выберите текущий тип ремонта **/
  Repair = 'repair',
  /** Сколько лет ремонту? **/
  RepairAge = 'repairAge',
  /** Оцените стоимость ремонта. С учетом ремонта кухни, если он производился **/
  RepairCost = 'repairCost',
  /** Укажите количество комнат **/
  RoomCount = 'roomCount',
  /** Идентификатор подписки на оценку **/
  SubscriptionId = 'subscriptionId',
  /** Время до метро **/
  TimeToMetro = 'timeToMetro',
  /** Почему вас заинтересовала оценка? **/
  ValuationReason = 'valuationReason',
  /** Хотите, чтобы с вами связался риелтор, для уточнения оценки? **/
  WantRealtor = 'wantRealtor',
  /** Хотите сами выбрать риелторов для отправки заявки? **/
  WantToChooseRealtor = 'wantToChooseRealtor',
  /** Вот что нашлось по вашему адресу **/
  WhatIsFoundForAddress = 'whatIsFoundForAddress',
  /** Куда выходят окна? **/
  WindowsView = 'windowsView',
  /** Продаете вместе с техникой и мебелью? **/
  WithAppliancesOrFurniture = 'withAppliancesOrFurniture',
  /** Год постройки дома **/
  YearRelease = 'yearRelease',
}
export enum EAnswerType {
  /** Булево поле **/
  Bool = 'bool',
  /** Строковая енамка **/
  Enum = 'enum',
  /** Список строковых енамок **/
  EnumList = 'enumList',
  /** Число с плавающей точкой **/
  Float = 'float',
  /** Интовая енамка **/
  IntEnum = 'intEnum',
  /** Список интовых енамок **/
  IntEnumList = 'intEnumList',
  /** Положительное целое число **/
  Integer = 'integer',
  /** Объект с integer полями gte и lte **/
  Range = 'range',
  /** Строка **/
  String = 'string',
}
export enum ECode {
  /** Укажите адрес **/
  Address = 'address',
  /** «Магический шаг», во время которого фронт правит балом **/
  AddressMagic = 'addressMagic',
  /** Какая техника есть в квартире? **/
  Appliances = 'appliances',
  /** Оцените стоимость {техники и мебели} **/
  AppliancesAndFurnitureCost = 'appliancesAndFurnitureCost',
  /** Какая техника есть в квартире? (необязательный) **/
  AppliancesOptional = 'appliancesOptional',
  /** Укажите общую площадь **/
  Area = 'area',
  /** Укажите общую площадь (от и до) **/
  AreaRange = 'areaRange',
  /** Укажите высоту потолков **/
  CeilingHeight = 'ceilingHeight',
  /** Можно с детьми? **/
  ChildrenAllowed = 'childrenAllowed',
  /** Комфорт **/
  Comfort = 'comfort',
  /** Комфорт (необязательный) **/
  ComfortOptional = 'comfortOptional',
  /** Есть, что добавить? **/
  Comment = 'comment',
  /** Опишите вашу ситуацию **/
  ConsultationComment = 'consultationComment',
  /** Рассматриваете ли вы возможность начать сотрудничество с риэлтором? **/
  CooperationStatus = 'cooperationStatus',
  /** Как срочно хотите совершить сделку? 3/6/12 месяцев **/
  DealPeriod = 'dealPeriod',
  /** Скрытый шаг для проверки эксперимента **/
  DealPeriodHidden = 'dealPeriodHidden',
  /** Как срочно хотите совершить сделку? 7 дней / 2-3 недели / более месяца **/
  DealPeriodUrgent = 'dealPeriodUrgent',
  /** Чем риелтор может вам помочь? так-то это dealType, только странный **/
  DealTypeEx = 'dealTypeEx',
  /** Введите адрес электронной почты **/
  Email = 'email',
  /** Новостройка или вторичка? **/
  FirstOrSecond = 'firstOrSecond',
  /** Новостройка или вторичка? Или неважно **/
  FirstOrSecondExtended = 'firstOrSecondExtended',
  /** На каком этаже расположена квартира? **/
  Floor = 'floor',
  /** Сколько этажей в доме? **/
  FloorMax = 'floorMax',
  /** На каком этаже расположена квартира? (необязательный) **/
  FloorOptional = 'floorOptional',
  /** Форма подписки на оценку **/
  FormEvaluationSubscription = 'formEvaluationSubscription',
  /** Форма с выбранными риэлторами отправлена **/
  FormSentWithRealtors = 'formSentWithRealtors',
  /** Как вас зовут? **/
  FullName = 'fullName',
  /** Похоже, вы уже оценивали эту квартиру **/
  HasEstimation = 'hasEstimation',
  /** Скрытый шаг для отправки формы **/
  HiddenSubmitter = 'hiddenSubmitter',
  /** Укажите тип дома **/
  HouseMaterialType = 'houseMaterialType',
  /** Укажите тип дома (с вариантом «не знаю») **/
  HouseMaterialTypeDoNotKnow = 'houseMaterialTypeDoNotKnow',
  /** Вопрос, где нужно выбрать инфраструктуру **/
  Infrastructure = 'infrastructure',
  /** Вы агент по недвижимости? **/
  IsAgent = 'isAgent',
  /** Объект в залоге у банка? **/
  IsBankDeposit = 'isBankDeposit',
  /** Планируете брать кредит? **/
  IsCredit = 'isCredit',
  /** Вы уже разместили объявление? **/
  IsHasOffer = 'isHasOffer',
  /** Вы получили квартиру в наследство? **/
  IsInheritance = 'isInheritance',
  /** В числе собственников есть несовершеннолетние? **/
  IsMinorOwners = 'isMinorOwners',
  /** Уже накопили на первоначальный взнос? **/
  IsMortgageInitialPayment = 'isMortgageInitialPayment',
  /**  **/
  IsOfferDataCorrect = 'isOfferDataCorrect',
  /** Вы знаете параметры квартиры и дома? **/
  IsOfferParamsKnown = 'isOfferParamsKnown',
  /** Уже выбрали проект дома под строительство? **/
  IsProjectExists = 'isProjectExists',
  /** Вы готовы снизить цену, в случае необходимости? **/
  IsReadyToLower = 'isReadyToLower',
  /** В квартире такая планировка? **/
  Layout = 'layout',
  /** В квартире такая планировка? (необязательный) **/
  LayoutOptional = 'layoutOptional',
  /** Будете заключать договор аренды? **/
  LeaseAgreement = 'leaseAgreement',
  /** Есть лоджия или балкон? **/
  LoggiaOrBalcony = 'loggiaOrBalcony',
  /** Есть лоджия или балкон? **/
  LoggiaOrBalconyDoNotKnow = 'loggiaOrBalconyDoNotKnow',
  /** Уже есть одобрение ипотеки от банка? **/
  MortgageBankApprove = 'mortgageBankApprove',
  /** Рассматриваете вариант покупки участка и постройки {дома}? **/
  NeedLandForBuilding = 'needLandForBuilding',
  /** Хотите подобрать проект дома и рассчитать его примерную стоимость? **/
  NeedProject = 'needProject',
  /** Уточните тип недвижимости | Коммерческая **/
  ObjectTypeCommercial = 'objectTypeCommercial',
  /** Уточните тип недвижимости | Коммерческая (с готовым бизнесом) **/
  ObjectTypeCommercialWithBusiness = 'objectTypeCommercialWithBusiness',
  /** Уточните тип недвижимости | Жилая **/
  ObjectTypeFlat = 'objectTypeFlat',
  /** Уточните тип недвижимости | Загородка | Аренда и сдача **/
  ObjectTypeSuburban = 'objectTypeSuburban',
  /** Уточните тип недвижимости | Загородка | Покупка и продажа **/
  ObjectTypeSuburbanWithLand = 'objectTypeSuburbanWithLand',
  /** Выберите объявление **/
  Offer = 'offer',
  /** Какую недвижимость хотите продать? **/
  OfferType = 'offerType',
  /** Мы нашли объявления квартир с похожими параметрами. Вы хотите оценить квартиру из объявления? **/
  OffersFound = 'offersFound',
  /** В течение последних 10 лет в квартире производился капитальный ремонт? **/
  Overhaul = 'overhaul',
  /** Как срочно хотите совершить сделку? 1/2/4 недели **/
  PeriodShort = 'periodShort',
  /** Можно с животными? **/
  PetsAllowed = 'petsAllowed',
  /** Укажите номер мобильного телефона (с смс подтверждением) **/
  Phone = 'phone',
  /** Укажите номер мобильного телефона **/
  PhoneValue = 'phoneValue',
  /** Подтвердите номер мобильного телефона **/
  PhoneVerify = 'phoneVerify',
  /** Укажите предпочитаемую цену **/
  Price = 'price',
  /** Укажите предпочитаемую цену (диапазон) **/
  PriceRange = 'priceRange',
  /** Укажите предпочитаемую цену (диапазон) + включая коммунальные платежи **/
  PriceRangeWithCommunal = 'priceRangeWithCommunal',
  /** Укажите предпочитаемую цену (диапазон) + включая коммунальные платежи + включая эксплуатационные налоги **/
  PriceRangeWithCommunalAndOperational = 'priceRangeWithCommunalAndOperational',
  /** Укажите предпочитаемую цену + включая коммунальные платежи **/
  PriceWithCommunal = 'priceWithCommunal',
  /** Укажите предпочитаемую цену + включая коммунальные платежи + включая эксплуатационные налоги **/
  PriceWithCommunalAndOperational = 'priceWithCommunalAndOperational',
  /** Рассчитываем оценку **/
  ProgressBar = 'progressBar',
  /** Как планируете покупать квартиру? **/
  PurchaseMethod = 'purchaseMethod',
  /** Шаг с выбором риэлторов **/
  RealtorListing = 'realtorListing',
  /** Уточните срок аренды **/
  RentType = 'rentType',
  /** Выберите текущий тип ремонта **/
  Repair = 'repair',
  /** Сколько лет ремонту? **/
  RepairAge = 'repairAge',
  /** Сколько лет ремонту? (необязательный) **/
  RepairAgeDoNotKnow = 'repairAgeDoNotKnow',
  /** Оцените стоимость ремонта. С учетом ремонта кухни, если он производился **/
  RepairCost = 'repairCost',
  /** Выберите текущий тип ремонта (необязательный) **/
  RepairDoNotKnow = 'repairDoNotKnow',
  /** Укажите количество комнат **/
  RoomCount = 'roomCount',
  /** Укажите количество комнат. Доступен выбор нескольких **/
  RoomsCountMulti = 'roomsCountMulti',
  /** Заявка отправлена **/
  Success = 'success',
  /** Время до ближайшей станции метро **/
  TimeToMetro = 'timeToMetro',
  /** Почему вас заинтересовала оценка? **/
  ValuationReason = 'valuationReason',
  /** Хотите, чтобы с вами связался риелтор, для уточнения оценки? **/
  WantRealtor = 'wantRealtor',
  /** Хотите сами выбрать риелторов для отправки заявки? **/
  WantToChooseRealtor = 'wantToChooseRealtor',
  /** Вот что нашлось по вашему адресу **/
  WhatIsFoundForAddress = 'whatIsFoundForAddress',
  /** Куда выходят окна? **/
  WindowsView = 'windowsView',
  /** Продаете вместе с техникой и мебелью? **/
  WithAppliancesOrFurniture = 'withAppliancesOrFurniture',
  /** Продаете вместе с техникой и мебелью? (необязательный) **/
  WithAppliancesOrFurnitureOptional = 'withAppliancesOrFurnitureOptional',
  /** Год постройки дома **/
  YearRelease = 'yearRelease',
}
export enum EIconType {
  /** Иконки **/
  Icon = 'icon',
  /** Картинки **/
  Pictures = 'pictures',
}
export enum EType {
  /** Вопрос с указанием адреса без использования магии на фронте. **/
  Address = 'address',
  /** Вопрос с указанием email. По этому типу будет валидация **/
  Email = 'email',
  /** Вопрос с геосаджестом. По этому типу будет использован гео-саджест **/
  GeoSuggest = 'geoSuggest',
  /** Input. Пользователь сам вбивает строковое значение. **/
  Input = 'input',
  /** Вопрос, где нужно выбрать планировку **/
  Layout = 'layout',
  /** Можно выбрать несколько вариантов ответа **/
  MultiChoice = 'multiChoice',
  /** Number. Пользователь сам вбивает числовое значение. **/
  Number = 'number',
  /** Вопрос, где нужно выбрать объявление **/
  Offer = 'offer',
  /** Можно выбрать только 1 вариант ответа **/
  OneChoice = 'oneChoice',
  /** Вопрос с указанием номера телефона. По этому типу будет хук на подтверждение номера и валидация **/
  Phone = 'phone',
  /** Вопрос с указанием цены. По этому типу будет хук на запрос оценки и валидация **/
  Price = 'price',
  /** Вопрос, где нужно указать значение от и значение до **/
  Range = 'range',
  /** TextArea. Пользователь сам вбивает многострочное значение. **/
  Textarea = 'textarea',
  /** Вопрос, где нужно указать время до точки **/
  Time = 'time',
}
